export const stringToJson = (str: string): any => {
  return str ? JSON.parse(str) : "";
}